const UPDATE_RECORD = 'scratch-gui/account/UPDATE_RECORD';

const initialState = {
    record: localStorage.getItem('account') ? localStorage.getItem('account') : ''
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_RECORD:
        return Object.assign({}, state, {
            record: action.record
        });
    default:
        return state;
    }
};

const updateRecord = function (record) {
    localStorage.setItem('account', record);
    return {
        type: UPDATE_RECORD,
        record: record
    };
};

export {
    reducer as default,
    initialState as accountInitialState,
    updateRecord
};
